<div class="header">
  <div class="title">役職変更</div>
</div>
<mat-dialog-content>
  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
    <div class="form-area">
      <form [formGroup]="form">
        <div class="flex">
          <div class="label">ID</div>
          <mat-form-field class="input-area no-line">
            <input matInput
              formControlName="mailaddress"
              readonly
              (input)="onInput()"
              type="text"
              />
          </mat-form-field>
        </div>
        <div class="flex">
          <div class="label">役職</div>
          <mat-form-field floatLabel="never" class="field-auth no-line">
            <mat-select
              formControlName="officialposition"
              panelClass="tagcategory-select account-role-select-panel"
              [panelWidth]="isSp ? 'auto' : 352"
              >
            <mat-option *ngFor="let role of roleOptions" [value]="role.id">
              {{ role.name }}
            </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex">
          <div class="label">権限</div>
          <div class="authority-plain-text">{{ selectedAuthorityLabel }}</div>
        </div>
    </form>
  </div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving || !isRoleSelected" class="yes-btn">保存</button>
</mat-dialog-actions>
